import { GET_USER_DATA } from "../actions/types";
const INITIAL_STATE = {
  userData: "",
};

export default (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case GET_USER_DATA:
      return { ...state, userData: action.payload, isLoading: false };
    default:
      return state;
  }
};
